import styled from "styled-components";

const StyledHeroTextInside = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  padding-top: 94px;
  padding-bottom: 80px;
  @media screen and (max-width: 1023px){
    padding-top: 94px;
    padding-bottom: 64px;
  }
  .wrapper-hero{
    position: relative;
    width: 100%;
    height: 60vh;
    display: flex;
    align-items: center;
  }
  h4 {
    position: relative;
    z-index: 2;
    padding: 0 64px;
    width: 66.66%;
    color: #fff;
    @media screen and (max-width: 1439px){
      padding: 0 40px;
    }
    @media screen and (max-width: 1023px){
      padding: 0 20px;
      width: auto;
    }
  }
  .background-image { 
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background-size: cover;
    background-position-x: 100%;
    width: 100%;
    height: 100%;
  }
`;

export {
  StyledHeroTextInside
}
